import { openExternalApp } from "./mediatorUtils";

export const costumerSupportURL = "https://support.tvg.com/s/";

export const openLiveChat = () => {
  openExternalApp(costumerSupportURL);
};
